import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    tellUsMoreInputLabel: 'Tell us more (optional)',
    tellUsMoreInputPlaceholder: 'Your answer',
    title: 'We’re sorry to see you go…',
  },
  fr: {
    tellUsMoreInputLabel: 'Pourriez-vous nous en dire plus ? (facultatif)',
    tellUsMoreInputPlaceholder: 'Votre réponse',
    title: 'Quel dommage de vous voir partir…',
  },
});

export default locales;
